'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var themeTools = require('@chakra-ui/theme-tools');
var heading = require('./heading.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var parts = ['card', 'header', 'body', 'footer', 'imageWrapStyles', 'image'];
var defaultP = {
  base: 4,
  md: 6
};
var baseStyle = function baseStyle(props) {
  var c = props.colorScheme,
    theme = props.theme;
  return {
    card: {
      py: defaultP,
      pr: defaultP,
      pl: 4,
      border: '1px',
      borderColor: "".concat(c, ".400"),
      bg: themeTools.transparentize("".concat(c, ".400"), 0.2)(theme),
      borderRadius: 'base',
      boxShadow: 'sm'
    },
    header: _objectSpread(_objectSpread({}, heading["default"].baseStyle), heading["default"].sizes.h2),
    body: {},
    footer: {
      pt: 2
    },
    image: {}
  };
};
var defaultProps = {
  colorScheme: 'yellow'
};
var HighlightCard = {
  parts: parts,
  baseStyle: baseStyle,
  defaultProps: defaultProps
};
exports["default"] = HighlightCard;